export default defineNuxtRouteMiddleware(() => {
  const config = useRuntimeConfig()
  // Check if insure module is available
  if (config.public.insureAvailable !== 'true') {
    throw createError({
      statusCode: 404,
      statusMessage: 'Insurance is currently unavailable',
    })
  }
})
